import { render } from "./MedicalRegister.vue?vue&type=template&id=d2b0e3de&scoped=true"
const script = {}

import "./MedicalRegister.vue?vue&type=style&index=0&id=d2b0e3de&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b0e3de"]])

export default __exports__